"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AddCircle;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function AddCircle(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Arrows_",
    "data-name": "Arrows+"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "add-circle"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "compound",
    d: "M52.5,26.43V47.5H73.57a2.5,2.5,0,1,1,0,5H52.5V73.57a2.5,2.5,0,0,1-5,0V52.5H26.43a2.5,2.5,0,0,1,0-5H47.5V26.43a2.5,2.5,0,0,1,5,0ZM80.05,20A42.5,42.5,0,1,1,20,20,42.54,42.54,0,0,1,80.05,20Zm-3.53,3.53a37.5,37.5,0,1,0,0,53A37.55,37.55,0,0,0,76.52,23.48Z"
  }))));
}